import React from 'react';

import "./Forms.scss";

const Button = React.forwardRef((props, ref) => {
	const { type = 'filled', isDisabled = true } = props
	const buttonType = type === 'filled' ? 'button-filled' : 'button-bordred'
	return (
		<div className={`button-wrapper ${props.classes}`}>
			<button 
				ref={ref}
				tabIndex='0' 
				type='button' 
				disabled={isDisabled} 
				className={`${buttonType}`} 
				onClick={props.handlClick} 
          		onKeyDown = {(e)=> e.key === 'Enter' && props.handlClick()} 
			>
				{props.children}
			</button>
		</div>
	);
})
export default Button;
